export default {"src":"/_next/static/media/rvn.fc843573.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};